export default () => ({
  dateTimeState: null,
  esrkNumberState: null,
  nameState: null
})
